import useNotyf from '@/hooks/useNotyf'
import { useShowGenericServerError } from '@/hooks/useShowGenericServerError'
import { API_VIOLATION_CODE, LONG_MESSAGE_DURATION } from '@/lib/constants'
import constraintViolationService from '@/lib/services/constraintViolationService'
import errorTypeService from '@/lib/services/errorTypeService'

export function useHandleCreateOrUpdateReferralLinkError() {
  const notyf = useNotyf()
  const showGenericServerError = useShowGenericServerError()

  const possibleErrorCodes = [
    API_VIOLATION_CODE.referralLinkNonStandaloneService,
    API_VIOLATION_CODE.missingReferralLinkIndividuals,
  ]

  function handleCreateOrUpdateReferralLinkError(error: unknown) {
    for (const errorCode of possibleErrorCodes) {
      const violation = constraintViolationService.getViolationByCode(
        error,
        errorCode,
      )

      if (violation) {
        notyf.errorWithoutReporting({
          message: violation.message,
          duration: LONG_MESSAGE_DURATION,
        })
        return
      }

      const entityLevelViolationError =
        errorTypeService.getEntityLevelViolationError(error)
      if (entityLevelViolationError) {
        notyf.error({
          message: entityLevelViolationError,
          duration: LONG_MESSAGE_DURATION,
        })
        return
      }
    }

    showGenericServerError()
  }

  return { handleCreateOrUpdateReferralLinkError }
}
